import { createSlice } from "@reduxjs/toolkit";
import {
  getStreamingEvents,
  getStreamingEventDetail,
} from "../actions/streamingActions";

const initialState = {
  events: {
    data: [],
    meta: null,
    isLoading: false,
    error: null,
  },
  eventDetail: {
    data: null,
    isLoading: false,
    error: null,
  },
};

const streamingSlice = createSlice({
  name: "streaming",
  initialState,
  reducers: {
    clearEvents: (state) => {
      state.events = initialState.events;
    },
    clearEventDetail: (state) => {
      state.eventDetail = initialState.eventDetail;
    },
  },
  extraReducers: (builder) => {
    // ── Events list ──
    builder.addCase(getStreamingEvents.pending, (state, action) => {
      // Only show full loader on first page
      if (!action.meta.arg?.page || action.meta.arg.page === 1) {
        state.events.isLoading = true;
      }
      state.events.error = null;
    });
    builder.addCase(getStreamingEvents.fulfilled, (state, action) => {
      state.events.isLoading = false;
      state.events.error = null;

      const { data, meta, page } = action.payload;

      if (!page || page === 1) {
        state.events.data = data ?? [];
      } else {
        // Append for infinite scroll
        state.events.data = [...state.events.data, ...(data ?? [])];
      }
      state.events.meta = meta ?? null;
    });
    builder.addCase(getStreamingEvents.rejected, (state, action) => {
      state.events.isLoading = false;
      state.events.error = action.error.message;
    });

    // ── Event detail ──
    builder.addCase(getStreamingEventDetail.pending, (state) => {
      state.eventDetail.isLoading = true;
      state.eventDetail.error = null;
    });
    builder.addCase(getStreamingEventDetail.fulfilled, (state, action) => {
      state.eventDetail.isLoading = false;
      state.eventDetail.error = null;
      state.eventDetail.data = action.payload;
    });
    builder.addCase(getStreamingEventDetail.rejected, (state, action) => {
      state.eventDetail.isLoading = false;
      state.eventDetail.error = action.error.message;
    });
  },
});

export const { clearEvents, clearEventDetail } = streamingSlice.actions;
export default streamingSlice.reducer;
